import { AccountPopover } from "@/components/AccountPopover/AccountPopover";
import { AccountPopoverRailFooterTrigger } from "@/components/AccountPopover/AccountPopoverRailFooterTrigger";
import { TokenMeter } from "@/components/billing/TokenMeter";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useOpenSettings } from "@/context/OpenSettingsContext";
import { Settings } from "lucide-react";

export function WorkspaceSidebarFooter() {
  const openSettings = useOpenSettings();

  return (
    <div className="flex items-center gap-2 border-t border-n-10 px-3 py-2.5">
      <AccountPopover popoverSide="top">
        <AccountPopoverRailFooterTrigger />
      </AccountPopover>

      <div className="shrink-0">
        <TokenMeter />
      </div>

      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label="Settings"
            onClick={() => openSettings()}
            className="inline-flex size-8 shrink-0 items-center justify-center rounded-md text-n-50 outline-none transition-colors hover:bg-n-05 hover:text-n-80 focus-visible:outline-2 focus-visible:outline-rust focus-visible:outline-offset-[-2px]"
          >
            <Settings className="size-4" />
          </button>
        </TooltipTrigger>
        <TooltipContent side="top">Settings</TooltipContent>
      </Tooltip>
    </div>
  );
}
